import React from 'react';
import { PopupboxManager, PopupboxContainer } from 'react-popupbox';

class DownloadCsvButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 'All',
      data: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  openPopupbox = (content) => {
    PopupboxManager.open({ content });
  };

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault(); // Don't allow form to submit itself
    // initiate the download in the browser
    window.location.assign(`/administration/user_reports/new?report_type=${this.state.value}`);
    PopupboxManager.close();
  }

  render() {
    const content = (
      <div className="col-md-12">
        <h3 className="solid-heading">Report Content Options</h3>
        <form onSubmit={this.handleSubmit}>
          <select className="form-control" onChange={this.handleChange}>
            <option value="All">All Users</option>
            <option value="StandardONLY">Standard Users Only</option>
            <option value="AdminONLY">Administrator Users Only</option>
            <option value="ManagerONLY">Manager Users Only</option>
          </select>
          <hr />
          <button className="btn btn-default btn-block" onClick={this.handleSubmit}>
            Download
          </button>
        </form>
      </div>
    );

    return (
      <div>
        <button className="button pull-right" onClick={() => this.openPopupbox(content)}>
          Download as .csv
        </button>
        <PopupboxContainer />
      </div>
    );
  }
}

export default DownloadCsvButton;
